export const blogData = [
  {
    id: 1,
    title: 'De toekomst van detachering in Nederland',
    excerpt: 'Hoe verandert de markt voor interim professionals en wat betekent dit voor Finance en HR?',
    date: '2025-05-08',
    category: 'Markt',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=85&auto=format&fit=crop',
    readTime: '5 min',
  },
  {
    id: 2,
    title: 'Staffing Force als eerste bureau B Corp gecertificeerd',
    excerpt: 'Trots dat wij als eerste detacheringsbureau in Nederland de B Corp certificering hebben ontvangen.',
    date: '2025-04-23',
    category: 'Nieuws',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=85&auto=format&fit=crop',
    readTime: '3 min',
  },
  {
    id: 3,
    title: '5 tips voor een succesvol sollicitatiegesprek',
    excerpt: 'Bereid je optimaal voor op je volgende sollicitatiegesprek met deze praktische tips.',
    date: '2025-04-02',
    category: 'Carrière',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=1200&q=85&auto=format&fit=crop',
    readTime: '4 min',
  },
  {
    id: 4,
    title: 'Duurzaamheid op de werkvloer: trends 2025',
    excerpt: 'Welke duurzaamheidstrends zien we op de werkvloer en hoe kunnen organisaties hierop inspelen?',
    date: '2025-03-20',
    category: 'Duurzaamheid',
    image: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=1200&q=85&auto=format&fit=crop',
    readTime: '6 min',
  },
  {
    id: 5,
    title: 'De rol van de Financial Controller in 2025',
    excerpt: 'Hoe evolueert de rol van de Financial Controller en welke vaardigheden worden steeds belangrijker?',
    date: '2025-03-06',
    category: 'Finance',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=85&auto=format&fit=crop',
    readTime: '5 min',
  },
  {
    id: 6,
    title: 'HR-transformatie: van administratie naar strategie',
    excerpt: 'De HR-functie verandert snel. Ontdek hoe HR-professionals strategische waarde toevoegen.',
    date: '2025-02-20',
    category: 'HR',
    image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=85&auto=format&fit=crop',
    readTime: '4 min',
  },
];

export const dienstenDetailData = {
  interim: {
    title: 'Interim Management',
    subtitle: 'Ervaren professionals voor tijdelijke opdrachten',
    description: 'Staffing Force levert ervaren interim managers op het gebied van Finance, HR en Duurzaamheid. Onze professionals zijn direct inzetbaar en leveren vanaf dag één resultaat.',
    features: [
      'Direct beschikbare professionals',
      'Van operationeel tot directieniveau',
      'Flexibele contractvormen',
      'Persoonlijke begeleiding gedurende de gehele opdracht',
      'Uitgebreid netwerk van ervaren interim managers',
    ],
    stats: { plaatsingen: '300+', gemiddeldeDuur: '6-12 maanden', klanttevredenheid: '9.2' },
  },
  wervingSelectie: {
    title: 'Werving & Selectie',
    subtitle: 'De juiste match voor een vaste positie',
    description: 'Op zoek naar de perfecte kandidaat voor een vaste functie? Met ons uitgebreide netwerk en jarenlange ervaring vinden wij het juiste talent voor uw organisatie.',
    features: [
      'Uitgebreid assessment en screeningsproces',
      'Grote database met gekwalificeerde kandidaten',
      'Marktkennis in Finance en HR',
      'Garantieregeling op plaatsingen',
      'Persoonlijke benadering van kandidaat en opdrachtgever',
    ],
    stats: { plaatsingen: '150+', succesRatio: '95%', gemiddeldeTijd: '4-6 weken' },
  },
  detavast: {
    title: 'Detavast',
    subtitle: 'Flexibel starten, vast eindigen',
    description: 'De detavast constructie biedt het beste van twee werelden: de flexibiliteit van detachering met het perspectief op een vast dienstverband.',
    features: [
      'Kennismakingsperiode via detachering',
      'Mogelijkheid tot vast dienstverband',
      'Minder risico voor beide partijen',
      'Professionele begeleiding gedurende het traject',
      'Soepele overgang van detachering naar vast',
    ],
    stats: { conversie: '85%', gemiddeldeDuur: '3-6 maanden', tevredenheid: '9.4' },
  },
  duurzaamheid: {
    title: 'Duurzaamheidsconsultants',
    subtitle: 'Experts in duurzame bedrijfsvoering',
    description: 'Wij leveren gespecialiseerde duurzaamheidsconsultants die organisaties helpen bij het ontwikkelen en implementeren van hun duurzaamheidsstrategie.',
    features: [
      'CSRD en ESG rapportage expertise',
      'Strategische duurzaamheidsadvisering',
      'Implementatie van duurzaamheidsbeleid',
      'Stakeholder engagement en communicatie',
      'Carbon footprint analyse en reductie',
    ],
    stats: { projecten: '50+', sectoren: '12+', ervaring: '10+ jaar' },
  },
};

export const kandidaatVoordelenData = [
  { title: 'Persoonlijke begeleiding', description: 'Een vaste contactpersoon die u gedurende de gehele opdracht begeleidt en ondersteunt.' },
  { title: 'Interessante opdrachten', description: 'Toegang tot unieke opdrachten bij toonaangevende organisaties in heel Nederland.' },
  { title: 'Opleidingsmogelijkheden', description: 'Investeer in uw ontwikkeling met onze opleidings- en trainingsmogelijkheden.' },
  { title: 'Competitieve beloning', description: 'Eerlijk en marktconform salaris met uitstekende secundaire arbeidsvoorwaarden.' },
  { title: 'Flexibiliteit', description: 'Kies de werkvorm die bij u past: interim, detavast of vast dienstverband.' },
  { title: 'Netwerk', description: 'Word onderdeel van ons groeiende netwerk van professionals in Finance en HR.' },
];

export const opdrachtgeverVoordelenData = [
  { title: 'Snelle levering', description: 'Binnen 48 uur presenteren wij geschikte kandidaten dankzij ons uitgebreide netwerk.' },
  { title: 'Kwaliteitsgarantie', description: 'Al onze professionals worden zorgvuldig gescreend en getoetst op vakkennis en ervaring.' },
  { title: 'Flexibele oplossingen', description: 'Van interim management tot werving & selectie - wij bieden de juiste oplossing voor elke vraag.' },
  { title: 'Marktkennis', description: '18+ jaar ervaring in Finance en HR geeft ons diepgaande kennis van de arbeidsmarkt.' },
  { title: 'Duurzame relaties', description: 'Wij investeren in langdurige partnerschappen met onze opdrachtgevers.' },
  { title: 'B Corp gecertificeerd', description: 'Als B Corp gecertificeerd bureau staan wij voor duurzaam en verantwoord ondernemen.' },
];
